<template>
  <div />
</template>
<script>
export default {
  name: 'JsonLdItemList',
  props: {
    branch: {
      type: Object,
      required: true,
    },
    products: {
      type: Array,
      required: true,
    },
  },
  jsonld() {
    const jsonld = {
      '@context': 'http://schema.org',
      '@type': 'ItemList',
    }
    if (this.products) {
      jsonld.itemListElement = this.products.map((product, idx) => {
        return {
          '@type': 'ListItem',
          position: idx,
          url: `${this.$config.public.BASE_URL}/products/${product.product_id}`,
        }
      })
    }

    return jsonld
  },
}
</script>
